export default __webpack_public_path__ + "static/email-templates-composer-window-c35a88c062c1a77d1ba7f108a9cd703c.mp4";